import { Contract, Wallet, ethers } from "ethers";
import { equipUnequipPower, getNftMetadataByName, postArmorsItemsActivity, previewBeforeMergeNft } from "helpers/backend_helper";
import { createVoucher } from "helpers/common";
import { getNetworkUrl } from "helpers/constants";
import useWallet from "hooks/wallet";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { getCollection } from "store/actions";
import Web3Intraction from "util/web3Intraction";

export default function NftDroneEquipModal({
    nftData,
    userDetail,
  ...props
}) {
const [droneData,setDroneData] = useState(null);
const [btnLoader,setBtnLoader] = useState(false);
const [armorsCollection,setArmorsCollection] = useState(null);
const [previewImageSrc,setPreviewImageSrc] = useState(null)
const [previewLoading,setPreviwLoading]= useState(false);
const { settings } = useSelector((state) => state.Setting);
const dispatch = useDispatch();
const wallet = useWallet();

console.log("nftDAta",nftData)

useEffect(async()=>{
  try {
    if (wallet.account) return;
    console.log("cliecked");
    await wallet.initializeOnBoard();
    
    if (!wallet.account && settings?.blockchainNetworkMode && JSON.stringify(settings) !== "{}") {
      const networkUrl = getNetworkUrl("base", settings);
    console.log("networkUrl onConnectMetamask",networkUrl);
      wallet.connect(
        "metamask",
        networkUrl.chainId || 1
      );
      
    }
  } catch (err) {}
},[wallet.account]);

    useEffect(async()=>{
        try{
            if(nftData){
               
                const nftTrait = nftData.attributes.find((attribute) =>attribute.trait_type === "Drone");
                let traitName = nftTrait.value;
                if(nftData?.legendaryDroneDetails){
                   traitName = nftData?.legendaryDroneDetails?.equipment_trait;
                }
                const resSP = await getNftMetadataByName({nft_type : "legendary-drone", name : traitName});  
                console.log("Legendary response",resSP);
                if(resSP?.status === "success"){
                    setDroneData(resSP?.data);
                }
                

                let droneTraitName,equipmentStatus;
                if(nftData?.legendaryDroneDetails){
                  droneTraitName = nftData?.legendaryDroneDetails?.equipment_trait;
                  equipmentStatus = nftData?.legendaryDroneDetails?.equipment_status === "equiped" ? "unequiped" : "equiped";
                }else{
                  droneTraitName= resSP?.data?.name;
                  equipmentStatus = "unequiped";
                }
                let payload= {
                  type : "legendary-drone",
                  token_id :parseInt(nftData?.token_id),
                  equipment_token_id :resSP?.data?.edition,
                  equipment_status : equipmentStatus,
                  equipment_trait : droneTraitName,
              };
              setPreviwLoading(true);
                const respPreview = await previewBeforeMergeNft(payload);
                // console.log("respPreview.data",respPreview)
                // const base64 = Buffer.from(respPreview, 'binary').toString('base64');
                // const image = `data:image/png;base64,${base64}`;
                setPreviewImageSrc(respPreview?.data);
                setPreviwLoading(false);

                
             }
        }catch(err){
          setPreviwLoading(false);
          console.log("error",err)
        }
     
    },[nftData]);

    useEffect(() => {
      if (settings && settings.activeArmorsCollectionId) {
        dispatch(getCollection(settings.activeArmorsCollectionId,(data)=>{
          setArmorsCollection(data);
        }));
      }
    }, [JSON.stringify(settings)]);

    const onSubmit = async (e) =>{
        e.preventDefault();

        try{
          if(!droneData?._id){
            return toast.error("Metadata details missing!")
        }
        if(!previewImageSrc){
          return toast.error("Preview image missing, Something went wrong!")
        }

        //testing code - 
        setBtnLoader(true);
        if (
          !armorsCollection ||
          !armorsCollection.contractAbi ||
          !settings ||
          JSON.stringify(settings) === "{}"
        ) {
          setBtnLoader(false);
          return toast.error("Armors collection not found!");
        }
        if (!wallet.account) {
          setBtnLoader(false);
          return toast.error(`Make sure your metamask connected.`);
        }
        const web3Intraction = new Web3Intraction(
          armorsCollection.blockchain,
          settings
        );

        const PROVIDER = new ethers.providers.Web3Provider(
          wallet.provider,
          web3Intraction.networkUrl
            ? {
                name: web3Intraction.networkUrl.chainName,
                chainId: Number(web3Intraction.networkUrl.chainId)
              }
            : "any"
        );
        console.log("PROVIDER", PROVIDER);
        const SIGNER = PROVIDER.getSigner();
        console.log("SIGNER", SIGNER);
        // console.log(collection, "collection")
        let ethercontract = new Contract(
          armorsCollection.contractAddress,
          JSON.parse(armorsCollection.contractAbi),
          SIGNER
        );
        console.log("ethercontract",ethercontract)
          
        const contract = await web3Intraction.getContract(
          armorsCollection.contractAbi,
          armorsCollection.contractAddress
        );
    console.log("contract",contract)
        if (!contract || !ethercontract) {
           setBtnLoader(false);
      return toast.error("Service not provided!");
    }

    const networkUrl = getNetworkUrl("base", settings);
    console.log("networkUrl",networkUrl);
    let chainID = networkUrl?.chainId;
    if (
      wallet.account &&
      wallet.account?.toLowerCase() ===
        userDetail?.walletAddress?.toLowerCase()
    ) {
      
        await wallet.switchNetwork(
          chainID
      );
     
    } else {
      setBtnLoader(false);
      return toast.error(
        `Make sure your metamask connected account is same as primary wallet : ${userDetail?.walletAddress}`
      );
    }

        // console.log(collection, "collection")
        const voucher = await createVoucher(
          nftData.edition,
          droneData.edition,
          wallet.account,
          armorsCollection.contractAddress,
          networkUrl.chainId
        );
        console.log("vouchervouchervoucher",voucher)
        
          if (!voucher) {
            toast.error("Error while create security data.");
            return;
          }

        let droneTraitName,equipmentStatus;
        if(nftData?.legendaryDroneDetails){
          droneTraitName = nftData?.legendaryDroneDetails?.equipment_trait;
          equipmentStatus = nftData?.legendaryDroneDetails?.equipment_status === "equiped" ? "unequiped" : "equiped";
        }else{
          droneTraitName= droneData.name;
          equipmentStatus = "unequiped";
        }
        let txHash;
        let transaction;
        let action;
        let quantity;
//         console.log("contract",contract)
//         quantity = await contract.methods.balanceOf(wallet.account,droneData.edition).call();
// console.log("quantity",quantity)
      if(nftData?.legendaryDroneDetails?.equipment_status === "unequiped"){

         transaction = await ethercontract.roboticBurn(
          voucher
       );
        action = "burn";
        quantity = 1;
      }else{
        console.log("mint",nftData.edition,droneData.edition)
         transaction = await ethercontract.roboticMint(
          voucher
       );
        action = "mint";
        quantity = 1;
      }
      
      const tx = await transaction.wait();
      console.log("tx", tx);
      txHash = tx.transactionHash;

        // console.log("receipt after mint",receipt);
        if (!txHash) {
          setBtnLoader(false);
          return;
        }
           
            let payload= {
              type : "legendary-drone",
              token_id :parseInt(nftData?.token_id),
              equipment_token_id :droneData.edition,
              equipment_status : equipmentStatus,
              equipment_trait : droneTraitName,
              blockchain: "base",
              collection_id: armorsCollection?._id,
              walletAddress: wallet.account,
              transactionHash: txHash,
              userId:userDetail._id,
              previewImageLink: previewImageSrc
          };
            const resSP = await equipUnequipPower(payload);  
            setBtnLoader(false);
            if(resSP?.status === "success"){
              const payload = {
                collection_id: armorsCollection?._id,
                walletAddress: wallet.account,
                author_id: userDetail._id,
                token_ids: [parseInt(droneData.edition)],
                price: 0,
                mint_type: "armors",
                nft_type : "legendary-drone",
                transactionHash: txHash,
                type: armorsCollection.blockchain || "base",
                quantity: quantity,
                action : action,
              };
               props.onhide();
               await postArmorsItemsActivity(payload);
               window.location.reload();
            }
                    console.log("Special Power response",resSP);
        }catch(err){
            setBtnLoader(false);
            toast.error(err?.message || "Something went wrong!")

        }finally{
            setBtnLoader(false);
        }
       
    };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="wistlist_mod editmod confirm_modal"
    >
      <Modal.Body>
      <h4 className="text-white">Legendary Drone</h4>
        <div className="editmod_inner pt-5">
            
          <a
            href="javascript:void(0)"
            className="close_icon"
            onClick={props.onhide}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="39"
              height="39"
              viewBox="0 0 39 39"
              fill="none"
            >
              <path
                d="M12.75 28.875L19.5 22.125L26.25 28.875L28.875 26.25L22.125 19.5L28.875 12.75L26.25 10.125L19.5 16.875L12.75 10.125L10.125 12.75L16.875 19.5L10.125 26.25L12.75 28.875ZM19.5 38.25C16.9062 38.25 14.4688 37.7575 12.1875 36.7725C9.90625 35.7875 7.92188 34.4519 6.23438 32.7656C4.54688 31.0781 3.21125 29.0938 2.2275 26.8125C1.24375 24.5312 0.75125 22.0938 0.75 19.5C0.75 16.9062 1.2425 14.4688 2.2275 12.1875C3.2125 9.90625 4.54813 7.92188 6.23438 6.23438C7.92188 4.54688 9.90625 3.21125 12.1875 2.2275C14.4688 1.24375 16.9062 0.75125 19.5 0.75C22.0938 0.75 24.5312 1.2425 26.8125 2.2275C29.0938 3.2125 31.0781 4.54813 32.7656 6.23438C34.4531 7.92188 35.7894 9.90625 36.7744 12.1875C37.7594 14.4688 38.2513 16.9062 38.25 19.5C38.25 22.0938 37.7575 24.5312 36.7725 26.8125C35.7875 29.0938 34.4519 31.0781 32.7656 32.7656C31.0781 34.4531 29.0938 35.7894 26.8125 36.7744C24.5312 37.7594 22.0938 38.2513 19.5 38.25Z"
                fill="#fff"
              />
            </svg>
          </a>
         {!droneData ? 
          <div className="d-flex justify-content-center text-white"> No Drone found</div>
          :
          <Form onSubmit={onSubmit}>
            <Row className="text-center justify-content-center">
              <Col md="6" className="my-2">
                   <div className="equip-nft-cards mx-auto">
                    <div className="img-wrap">
                     <img src={droneData?.image} width={150} height={150}/>
                    </div>
                     <p className="text-center text-white my-2">{droneData?.name}</p>
                   </div>
              </Col>
              <Col md="6" className="my-2">
                   <div className="equip-nft-cards mx-auto text-center">
                   <div className="img-wrap ">
                   {previewImageSrc && <img src={previewImageSrc} width={150} className="" height={150}/>}
                   {previewLoading && !previewImageSrc && <Spinner size="md" style={{color:"#fff"}}/>}
                   {/* {previewLoading && 
                     <div className="bg_box">
                        <img src={nftData?.metadata?.image} width={150} height={150}/>
                     </div>
                    } */}
                   {!previewLoading && !previewImageSrc && <span className="text-white">No Preview</span>}
                   </div>
                     <p className="text-white my-2">Preview</p>
                   </div>
                   
              </Col>
               
               
            </Row>
            <div className="btn-submit d-flex gap-3 mt-5">
              <Button
                type="submit"
                disabled={btnLoader || !previewImageSrc}
                className="btnsubmit"
              >{btnLoader && <Spinner size="sm" color="light" className="mr-2 me-2" />}
               Confirm
              </Button>
            </div>
          </Form>
}
        </div>
      </Modal.Body>
    </Modal>
  );
}
